/** @format */

import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'homefield-price',
  templateUrl: './price.component.html',
  styleUrl: './price.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class HomefieldPriceComponent {
  @Input() isSeePriceInCart = false;

  @Input() isClearance = false;

  @Input() pricingInfo: any;
}
